import { Box, Button, Divider, Grid, TextField, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../common/style/Theme"
import { default as logo } from "../../assets/logo.png"
import { useNavigate } from "react-router-dom";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const Footer = (props) => {
    const navigate = useNavigate();
    
    // Media queries for responsive design
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

    const handleNavigation = (item) => {
        navigate(item.link);
        window.scroll({
            top: 0,
            behavior: 'smooth'
        })
    }
    return (
        <Box container style={{
            marginTop: "50px",
            background: `linear-gradient(194deg, ${theme.palette.primary.main}, ${theme.palette.common.black})`,
            paddingTop: isMobile ? "8vw" : "5vw",
            paddingBottom: isMobile ? "5vw" : "3vw",
        }}>
            <Grid container style={{
                background: theme.palette.background.paper,
                padding: isMobile ? "20px 5vw" : isTablet ? "20px 8vw" : "20px 10vw",
            }}>
                <Grid size={{xs:12, sm:12, md:8, lg:8}} style={{
                    display:"flex",
                    justifyContent: isMobile ? "center" : "flex-start",
                    alignItems: "center",
                    backgroundColor: theme.palette.background.paper,
                    marginBottom: isMobile ? "20px" : "0",
                    textAlign: isMobile ? "center" : "left",
                }}>
                    <Box style={{
                        width: isMobile ? "80px" : "100px",
                        height: isMobile ? "80px" : "100px",
                    }}>
                        <img src={logo} alt="Logo" style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            objectPosition: "center",
                        }} />
                    </Box>
                    <Typography variant={isMobile ? "h6" : "h5"} style={{
                        fontWeight: 600,
                        marginLeft: isMobile ? "8px" : "10px",
                    }}>
                        M5 Info Solutions
                    </Typography>
                </Grid>
                <Grid size={{xs:12, sm:12, md:4, lg:4}} style={{
                    textAlign: isMobile ? "center" : "left",
                }}>
                    <Typography variant="body2" style={{
                        marginBottom: "5px",
                    }}>Join our news letter</Typography>
                    <Box style={{
                        display:"flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? "10px" : "20px",
                        alignItems: "center",
                    }}>
                        <TextField 
                            name="email"
                            type="email"
                            placeholder="Enter your email"
                            variant="outlined"
                            fullWidth
                            sx={{
                                "& .MuiOutlinedInput-input": {
                                    padding: isMobile ? "8px 12px" : "10px 14px",
                                    fontSize: isMobile ? "0.9rem" : "inherit",
                                }
                            }}
                        />
                        <Button variant="contained" style={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.common.white,
                            minWidth: isMobile ? "100%" : "auto",
                        }}>
                            Subscribe
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <Grid container style={{
                padding: isMobile ? "20px 5vw" : isTablet ? "20px 8vw" : "20px 10vw",
                color: theme.palette.common.white,
            }}>
                <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{}}>
                    <Box style={{
                        display:"flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? "30px" : isTablet ? "60px" : "100px",
                        marginTop: "30px",
                        justifyContent: isMobile ? "center" : "flex-start",
                        alignItems: isMobile ? "center" : "flex-start",
                    }}>
                        {props.navItems?.map((item, i) => (
                            <Box key={i} style={{
                                textAlign: isMobile ? "center" : "left",
                                minWidth: isMobile ? "200px" : "auto",
                            }}>
                                <Typography variant="h6" 
                                    style={{
                                        cursor: "pointer",
                                        marginBottom: isMobile ? "15px" : "10px",
                                    }}
                                    onClick={() => handleNavigation(item)}
                                >
                                    {item.name}
                                </Typography>
                                <Box style={{marginTop: "10px"}}>
                                    {item.isMenu && item.menuItems?.map((menuItem, j) => (
                                        <Typography variant="body2" key={j} 
                                            style={{
                                                cursor: "pointer", 
                                                marginTop: isMobile ? "12px" : "8px",
                                                lineHeight: isMobile ? "1.6" : "1.43",
                                            }}
                                            onClick={() => handleNavigation(menuItem)}
                                        >
                                            {menuItem.name}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>
                        ))}
                        <Box>
                            <Typography variant="h6" style={{ marginBottom: "10px" }}>
                                M5 Info Solutions Pvt. Ltd.
                            </Typography>
                            <Typography variant="body2">
                                #54/3, 2nd Cross 1st R Block Rajajinagar,<br />
                                Bangalore - 560010,<br />
                                India
                            </Typography>
                            <Box style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                margin: "20px 0", 
                                cursor: "pointer" 
                            }}>
                                <PhoneIcon style={{ marginRight: 12, fontSize: 24 }} />
                                <Typography variant="body1" style={{ fontWeight: 500 }}>
                                    080-23577966
                                </Typography>
                            </Box>
                            <Box style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                margin: "20px 0", 
                                cursor: "pointer" 
                            }}>
                                <EmailIcon style={{ marginRight: 12, fontSize: 24 }} />
                                <Typography variant="body1" style={{ fontWeight: 500 }}>
                                    info@m5infosolutions.com
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
                <Grid size={{xs:12, sm:12, md:12, lg:12}}>
                    <Divider style={{
                        margin: isMobile ? "2vw 0" : "3vw 0",
                        borderColor: theme.palette.background.paper,
                        opacity: 0.2,
                    }}/>
                </Grid>
                <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{
                    display:"flex",
                    flexDirection: isMobile ? "column" : "row",
                    justifyContent: isMobile ? "center" : "space-between",
                    alignItems: isMobile ? "center" : "flex-start",
                    gap: isMobile ? "15px" : "0",
                    textAlign: isMobile ? "center" : "left",
                }}>
                    <Typography variant="body2">
                        © 2025 M5 Info Solutions Pvt Ltd. All rights reserved.
                    </Typography>
                    <Box style={{
                        display:"flex", 
                        gap: isMobile ? "15px" : "20px",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: "center",
                    }}>
                        <Typography variant="body1" style={{
                            cursor: "pointer",
                        }}>
                            Privacy
                        </Typography>
                        <Typography variant="body1" style={{
                            cursor: "pointer",
                        }}>
                            Terms
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Footer;